import React, { useState } from 'react'
import { useSelector } from 'react-redux';

import Swal from 'sweetalert2'
import Layout from '../../../components/layout/layout'

import TablaPresupuesto from './Departamento/TablaPresupuesto'
import TablaNomina from './Departamento/TablaNomina'
import TablaPrestaciones from './Departamento/TablaPrestaciones'


import TablaPresupuestoObra from './Obra/TablaPresupuestoObra'
import Editar from './Departamento/EditarPresupuestoDepartamento'
// import Ver from './Departamento/VerPresupuestoDepartamento'
import Ver from './Departamento/VerDetalle'


import EditarObra from './Obra/EditarPresupuestoObra'
import VerObra from './Obra/VerPresupuestoObra'

import {Tabs, Tab } from 'react-bootstrap'
import { Modal } from '../../../components/singles'

import Tabla from '../../../components/NewTables/TablaGeneral/TablaGeneral'
import { apiDelete, apiPutForm } from '../../../functions/api'

export default function Presupuesto() {
    const userAuth = useSelector((state) => state.authUser);
    const [reloadTable, setReloadTable] = useState()
    const [reloadTableObra, setReloadTableObra] = useState()
    const specificPermission = userAuth.user.permisos.find(permission => permission.modulo_id === 17);

    const [modal, setModal] = useState({
        nuevo: {
            show: false,
            data: null
        },
        nomina: {
            show: false,
            data: null
        },
        prestaciones: {
            show: false,
            data: null
        },
        editar: {
            show: false,
            data: null
        },
        ver: {
            show: false,
            data: null
        }
    })


    const [modalObra, setModalObra] = useState({
        nuevo: {
            show: false,
            data: null
        },
        editar: {
            show: false,
            data: null
        },
        ver: {
            show: false,
            data: null
        }
    })

    const [key, setKey] = useState('departamentos');

    let prop = {
        pathname: '/administracion/requisicion',
    }

    const setKeyTab = (key) => {
        setKey(key)
    }

    
    const formatNumberCurrency = (number) => {
        return new Intl.NumberFormat('es-MX', {
            style: 'currency',
            currency: 'MXN',
            minimumFractionDigits: 2
        }).format(number)
    }

    const formatDateString = (date) => {
        let aux = date.split('-')
        return aux[2] + '/' + aux[1] + '/' + aux[0]
    }

    const tagAprobado = (value) => {
        if (value === '0') {
            return <span className="badge badge-danger">No autorizado</span>
        } else {
            return <span className="badge badge-success">Autorizado</span>
        }
    }

    // Departamentos

    const ProccessData = (e) => {
        let aux = []
        // console.log(e)
        e.presupuesto.map(item => {
            aux.push({
                id: item.id,
                id_area: item.id_area,
                nombre: item.nombre +' / '+ item.fecha_inicio,
                empresa: item.empresa &&  item.empresa[0] ?  item.empresa[0].name : 'Sin Empresa',
                fecha: formatDateString(item.fecha),
                monto: item.presupuesto,
                monto_show: formatNumberCurrency(item.presupuesto),
                departamento: item.area ? item.area.nombre :'',
                usuario: item.usuario ? item.usuario.name : '',
                autorizacion: tagAprobado(item.estatus),
                estatus: item.estatus === "1" ? true : false,
                presupuesto_autorizado: item.presupuesto_autorizado ? formatNumberCurrency(item.presupuesto_autorizado) : '',
                presupuesto_gastado: item.total_monto_pago ? formatNumberCurrency(item.total_monto_pago) : '',
                presupuesto_restante: (
                Number.isFinite(item.presupuesto_autorizado) && Number.isFinite(item.total_monto_pago)
                    ? formatNumberCurrency(Math.max(0, item.presupuesto_autorizado - item.total_monto_pago))
                    : ''
                )          
              })
        })
        return aux
    }

    const columnas = [
        { nombre: 'Acciones', identificador: 'acciones' },
        { nombre: 'Departamento', identificador: 'departamento', sort: false, },
        { nombre: 'Empresa', identificador: 'empresa', sort: false, },
        { nombre: 'usuario', identificador: 'usuario', sort: false, },
        { nombre: 'Nombre', identificador: 'nombre', sort: false, },
        { nombre: 'Fecha', identificador: 'fecha', sort: false, stringSearch: false },
        { nombre: 'Ppto. autorizado', identificador: 'presupuesto_autorizado', sort: false, stringSearch: false },
        { nombre: 'Ppto. Gastado', identificador: 'presupuesto_gastado', sort: false, stringSearch: false },
        { nombre: 'Ppto. Restante', identificador: 'presupuesto_restante', sort: false, stringSearch: false },
        { nombre: 'Autorización', identificador: 'autorizacion', sort: false, stringSearch: false },
    ]

    const createAcciones = () => {
        let acciones = [
            {
                nombre: 'Ver',
                color: 'blueButton',
                icono: 'fas fa-eye',
                funcion: (item) => {
                    setModal({
                        ...modal,
                        ver: {
                            show: true,
                            data: item
                        }
                    })
                }
            },
            {
                nombre: 'Editar',
                color: 'blueButton',
                icono: 'fas fa-edit',
                funcion: (item) => {
                    if (userAuth.user.tipo.tipo === 'Administrador') {
                        setModal({
                            ...modal,
                            editar: {
                                show: true,
                                data: item
                            }
                        })
                    } else {
                        Swal.fire({
                            title: '¡No tienes permisos!',
                            text: "¡No tienes permisos para editar el presupuesto!",
                            icon: 'error',
                            confirmButtonColor: '#3085d6',
                            confirmButtonText: 'Ok'
                        })
                    }
                }
            },
            {
                nombre: 'Eliminar',
                color: 'redButton',
                icono: 'fas fa-trash-alt',
                funcion: (item) => {
                    if (userAuth.user.tipo.tipo === 'Administrador') {
                        Swal.fire({
                            title: '¿Estas seguro?',
                            text: "¡No podrás revertir esto!",
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#d33',
                            cancelButtonText: 'Cancelar',
                            confirmButtonText: 'Si, eliminar'
                        }).then((result) => {
                            if (result.isConfirmed) {
                                try {
                                    apiDelete(`presupuestosdep/${item.id}`, userAuth.access_token).then(result => {
                                        if (reloadTable) {
                                            reloadTable.reload()
                                        }
                                        Swal.fire({
                                            title: '¡Eliminado!',
                                            text: 'El presupuesto ha sido eliminado.',
                                            icon: 'success',
                                            confirmButtonColor: '#3085d6',
                                            confirmButtonText: 'Ok',
                                            timer: 2000
                                        })
                                    })
                                } catch (error) {

                                }
                            }
                        })
                    } else {
                        Swal.fire({
                            title: '¡No tienes permisos!',
                            text: "¡No tienes permisos para eliminar el presupuesto!",
                            icon: 'error',
                            confirmButtonColor: '#3085d6',
                            confirmButtonText: 'Ok'
                        })
                    }
                }
            },
            {
                nombre: 'Autorizar',
                color: 'perryButton',
                icono: 'fas fa-check',
                funcion: (item) => {
                    if (userAuth.user.tipo.tipo === 'Administrador') {
                        if (!item.estatus) {
                            Swal.fire({
                                title: '¿Estas seguro?',
                                text: "¡No podrás revertir esto!",
                                icon: 'warning',
                                showCancelButton: true,
                                confirmButtonColor: '#3085d6',
                                cancelButtonColor: '#d33',
                                cancelButtonText: 'Cancelar',
                                confirmButtonText: 'Si, autorizar'
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    Swal.fire({
                                        title: 'autorizando',
                                        text: 'Espere un momento...',
                                        allowOutsideClick: false,
                                        allowEscapeKey: false,
                                        allowEnterKey: false,
                                        showConfirmButton: false,
                                        onOpen: () => {
                                            Swal.showLoading()
                                        }
                                    })
                                    try {
                                        apiPutForm(`presupuestosdep/aprobacion/${item.id}`, { aprobado: 1 }, userAuth.access_token).then(result => {
                                            Swal.close()
                                            Swal.fire(
                                                '¡Autorizado!',
                                                'El presupuesto ha sido Autorizado.',
                                                'success'
                                            )
                                            if (reloadTable) {
                                                reloadTable.reload()
                                            }

                                        })
                                    } catch (error) {
                                        Swal.close()
                                        Swal.fire(
                                            '¡Error!',
                                            'El presupuesto no ha sido Autorizado.',
                                            'error'
                                        )

                                    }

                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Presupuesto ya autorizado',
                                text: "¡El presupuesto ya ha sido autorizado!",
                                icon: 'error',
                                confirmButtonColor: '#3085d6',
                                confirmButtonText: 'Ok'
                            })
                        }

                    } else {
                        Swal.fire({
                            title: '¡No tienes permisos!',
                            text: "¡No tienes permisos para aprobar el presupuesto!",
                            icon: 'error',
                            confirmButtonColor: '#3085d6',
                            confirmButtonText: 'Ok'
                        })
                    }
                }
            },
        ]
        return acciones
    }

    const opciones = [
        {
            nombre: 'Nuevo presupuesto',
            funcion: (item) => {
                if (userAuth.user.tipo.tipo === 'Administrador') {
                    setModal({
                        ...modal,
                        nuevo: {
                            show: true,
                            data: item
                        }
                    })
                }
            }
        },
        {
            nombre: 'Nueva nomina',
            funcion: (item) => {
                if (userAuth.user.tipo.tipo === 'Administrador') {
                    setModal({
                        ...modal,
                        nomina: {
                            show: true,
                            data: item
                        }
                    })
                }
            }
        },
        {
            nombre: 'Prestaciones',
            funcion: (item) => {
                if (userAuth.user.tipo.tipo === 'Administrador') {
                    setModal({
                        ...modal,
                        prestaciones: {
                            show: true,
                            data: item
                        }
                    })
                }
            }
        },
    ]

    const handleClose = (data) => () => {
        setModal({
            ...modal,
            [data]: {
                show: false,
                data: null
            }
        })
    }

    // Obras

    const columnasObras = [
        { nombre: 'Acciones', identificador: 'acciones' },
        { nombre: 'Departamento', identificador: 'departamento', sort: false, },
        { nombre: 'usuario', identificador: 'usuario', sort: false, },
        { nombre: 'Nombre', identificador: 'nombre', sort: false, },
        { nombre: 'Fecha', identificador: 'fecha', sort: false, stringSearch: false },
        { nombre: 'Ppto.', identificador: 'monto_show', sort: false, stringSearch: false },
        { nombre: 'Ppto. autorizado', identificador: 'presupuesto_autorizado', sort: false, stringSearch: false },
        { nombre: 'Autorización', identificador: 'autorizacion', sort: false, stringSearch: false },
    ]

    const ProccessDataObras = (e) => {
        let aux = []
        // console.log(e.presupuesto)
        e.presupuesto.map(item => {
            aux.push({
                data: item,
                id: item.id,
                id_area: item.id_area,
                nombre: item.nombre,
                fecha: formatDateString(item.fecha),
                monto: item.presupuesto,
                monto_show: formatNumberCurrency(item.presupuesto),
                departamento:item.area ?  item.area.nombre : 'Obra',
                usuario: item.usuario ? item.usuario.name : '',
                autorizacion: tagAprobado(item.estatus),
                estatus: item.estatus === "1" ? true : false,
                presupuesto_autorizado: item.presupuesto_autorizado ? formatNumberCurrency(item.presupuesto_autorizado) : ''
            })
        })
        return aux
    }

    const accionesObras = [
        {
            nombre: 'Editar',
            color: 'blueButton',
            icono: 'fas fa-edit',
            funcion: (item) => {
                setModalObra({
                    ...modalObra,
                    editar: {
                        show: true,
                        data: item
                    }   
                })

            }
        },
        {
            nombre: 'Ver',
            color: 'greenButton',
            icono: 'fas fa-eye',
            funcion: (item) => {
                console.log(item)
                setModalObra({
                    ...modalObra,
                    ver: {
                        show: true,
                        data: item
                    }
                })
            }
        },
        {
            nombre: 'Eliminar',
            color: 'redButton',
            icono: 'fas fa-trash-alt',
            funcion: (item) => {
                if (userAuth.user.tipo.tipo === 'Administrador') {
                    Swal.fire({
                        title: '¿Estas seguro?',
                        text: "¡No podrás revertir esto!",
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        cancelButtonText: 'Cancelar',
                        confirmButtonText: 'Si, eliminar'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            try {
                                apiDelete(`presupuestosdep/${item.id}`, userAuth.access_token).then(result => {
                                    if (reloadTableObra) {
                                        reloadTableObra.reload()
                                    }
                                    Swal.fire({
                                        title: '¡Eliminado!',
                                        text: 'El presupuesto ha sido eliminado.',
                                        icon: 'success',
                                        confirmButtonColor: '#3085d6',
                                        confirmButtonText: 'Ok',
                                        timer: 2000
                                    })
                                })
                            } catch (error) {

                            }
                        }
                    })
                } else {
                    Swal.fire({
                        title: '¡No tienes permisos!',
                        text: "¡No tienes permisos para eliminar el presupuesto!",
                        icon: 'error',
                        confirmButtonColor: '#3085d6',
                        confirmButtonText: 'Ok'
                    })
                }
            }
        },
        {
            nombre: 'Autorizar',
            color: 'perryButton',
            icono: 'fas fa-check',
            funcion: (item) => {
                if (userAuth.user.tipo.tipo === 'Administrador') {
                    if (!item.estatus) {
                        Swal.fire({
                            title: '¿Estas seguro?',
                            text: "¡No podrás revertir esto!",
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#d33',
                            cancelButtonText: 'Cancelar',
                            confirmButtonText: 'Si, autorizar'
                        }).then((result) => {
                            if (result.isConfirmed) {
                                Swal.fire({
                                    title: 'autorizando',
                                    text: 'Espere un momento...',
                                    allowOutsideClick: false,
                                    allowEscapeKey: false,
                                    allowEnterKey: false,
                                    showConfirmButton: false,
                                    onOpen: () => {
                                        Swal.showLoading()
                                    }
                                })
                                try {
                                    apiPutForm(`presupuestosdep/aprobacion/${item.id}`, { aprobado: 1 }, userAuth.access_token).then(result => {
                                        Swal.close()
                                        Swal.fire(
                                            '¡Autorizado!',
                                            'El presupuesto ha sido Autorizado.',
                                            'success'
                                        )
                                        if (reloadTableObra) {
                                            reloadTableObra.reload()
                                        }

                                    })
                                } catch (error) {
                                    Swal.close()
                                    Swal.fire(
                                        '¡Error!',
                                        'El presupuesto no ha sido Autorizado.',
                                        'error'
                                    )

                                }

                            }
                        })
                    } else {
                        Swal.fire({
                            title: 'Presupuesto ya autorizado',
                            text: "¡El presupuesto ya ha sido autorizado!",
                            icon: 'error',
                            confirmButtonColor: '#3085d6',
                            confirmButtonText: 'Ok'
                        })
                    }

                } else {
                    Swal.fire({
                        title: '¡No tienes permisos!',
                        text: "¡No tienes permisos para aprobar el presupuesto!",
                        icon: 'error',
                        confirmButtonColor: '#3085d6',
                        confirmButtonText: 'Ok'
                    })
                }
            }
        },
    ]

    const opcionesObras = [
        {
            nombre: 'Nuevo presupuesto',
            funcion: (item) => {
                setModalObra({
                    ...modalObra,
                    nuevo: {
                        show: true,
                        data: item
                    }
                })
            }
        },
        {
            nombre: 'Ver',
            color: 'greenButton',
            icono: 'fas fa-eye',
            funcion: (item) => {
                console.log(item)
                setModalObra({
                    ...modalObra,
                    ver: {
                        show: true,
                        data: item
                    }
                })
            }
        },
        
    ]

    const handleCloseObra = (data) => () => {
        setModalObra({
            ...modalObra,
            [data]: {
                show: false,
                data: null
            }
        })
    }

    return (
        <>

            <Layout authUser={userAuth.acces_token} location={prop} history={{ location: prop }} active='administracion'>
                {/* <TablaPresupuesto /> */}

                <Tabs defaultActiveKey="departamentos" activeKey={key} onSelect={(value) => { setKeyTab(value) }}>
                    <Tab eventKey="departamentos" title="Presupuestos departamentos">
                        <Tabla
                            titulo='Presupuestos'
                            columnas={columnas}
                            url='presupuestosdep'
                            ProccessData={ProccessData}
                            numItemsPagina={12}
                            acciones={createAcciones()}
                            opciones={opciones}
                            reload={setReloadTable}
                        />
                    </Tab>
                    <Tab eventKey="obra" title="Presupuestos Obra">
                        <Tabla
                            titulo='Obra'
                            columnas={columnasObras}
                            url='presupuestosdep/obra'
                            ProccessData={ProccessDataObras}
                            numItemsPagina={12}
                            acciones={accionesObras}
                            opciones={opcionesObras}
                            reload={setReloadTableObra}
                        />
                    </Tab>
                </Tabs>

            </Layout>

            <Modal size="xl" title={"Nuevo presupuesto"} show={modal.nuevo.show} handleClose={handleClose('nuevo')}>
                <TablaPresupuesto reload={reloadTable} handleClose={handleClose('nuevo')} />
            </Modal>

            <Modal size="xl" title={"Nueva nomina"} show={modal.nomina.show} handleClose={handleClose('nomina')}>
                <TablaNomina reload={reloadTable} handleClose={handleClose('nomina')} />
            </Modal>

            <Modal size="xl" title={"Prestaciones"} show={modal.prestaciones.show} handleClose={handleClose('prestaciones')}>
                <TablaPrestaciones reload={reloadTable} handleClose={handleClose('prestaciones')} />
            </Modal>
            {
                modal.editar.data &&
                <Modal size="xl" title={"Editar presupuesto"} show={modal.editar.show} handleClose={handleClose('editar')}>
                    <Editar data={modal.editar.data} reload={reloadTable} handleClose={handleClose('editar')} />
                </Modal>
            }

            {
                modal.ver.data &&
                <Modal size="xl"class="modal fade bd-example-modal-xl"  title={"Ver presupuesto"} show={modal.ver.show} handleClose={handleClose('ver')}>
                    <Ver data={modal.ver.data} reload={reloadTable} acceso={specificPermission} handleClose={handleClose('ver')} />
                </Modal>
            }

            <Modal size="xl" title={"Nuevo presupuesto"} show={modalObra.nuevo.show} handleClose={handleCloseObra('nuevo')}>
                <TablaPresupuestoObra reload={reloadTableObra} handleClose={handleClose('nuevoObra')} />
            </Modal>

            {
                modalObra.editar.data &&
                <Modal size="xl" title={"Editar presupuesto"} show={modalObra.editar.show} handleClose={handleCloseObra('editar')}>
                    <EditarObra data={modalObra.editar.data} reload={reloadTableObra} handleClose={handleCloseObra('editar')} />
                </Modal>
            }

            {
                modalObra.ver.data &&
                <Modal size="xl" title={"Ver presupuesto"} show={modalObra.ver.show} handleClose={handleCloseObra('ver')}>
                    <VerObra data={modalObra.ver.data} reload={reloadTableObra} handleClose={handleCloseObra('ver')} />
                </Modal>
            }

        </>
    );
}
